import { Component, OnDestroy, OnInit } from "@angular/core";
import { BroadcastService } from "@bbwt/modules/broadcasting";
import { AppStorage } from "@bbwt/utils/app-storage";
import { LayoutDataKeys } from "@main/app-layout/layout-data-keys";
import { LayoutEventKeys } from "@main/app-layout/layout-event-keys";
import { Subscription } from "rxjs";

@Component({
    selector: "after-login",
    templateUrl: "./after-login.component.html"
})
export class AfterLoginComponent implements OnInit, OnDestroy {
    private _subscription: Subscription;

    loginProcessed: boolean = false;
    twoFactorAuthBlock: boolean = false;

    constructor(private broadcastService: BroadcastService) {}

    ngOnInit() {
        this.userChanged2FAStatus(!!AppStorage.getItem<boolean>(LayoutDataKeys.IsMenuBlockedKey));
        this._subscription = this.broadcastService.on<boolean>(LayoutEventKeys.BlockMenuEventName).subscribe(twoFactorAuthBlock => {
            this.userChanged2FAStatus(twoFactorAuthBlock);
        });
    }

    ngOnDestroy(): void {
        this._subscription?.unsubscribe();
    }

    userChanged2FAStatus(twoFactorAuthBlock: boolean): void {
        // This case is just to avoid that the components are close suddenly if
        // the event of the subscription is shot more than once.
        if(this.loginProcessed && !this.twoFactorAuthBlock){
            return;
        }

        this.loginProcessed = !!AppStorage.getItem(AppStorage.LoginInProcess);
        this.twoFactorAuthBlock = twoFactorAuthBlock;

        if (this.loginProcessed && !twoFactorAuthBlock) {
            AppStorage.setItem(AppStorage.LoginInProcess, null);
        }
    }

    get showComponents(): boolean {
        return this.loginProcessed && !this.twoFactorAuthBlock;
    }
}
